import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Breadcrumbs,
  Link as MUILink,
} from "@mui/material";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { message, Modal } from "antd";
import moment from "moment";
import PageTitle from "../../Components/PageTitle";
import Table from "../common/Table";
import axios from "../../axiosInstance";

const OnlineFees = () => {
  const [search, setSearch] = useState("");
  const [onlineFees, setOnlineFees] = useState("");
  const [filteredOnlineFees, setFilteredOnlineFees] = useState([]);

  const getAllOnlineFees = async () => {
    const response = await axios.get("/api/v1/fees/get");
    setOnlineFees(response.data.data);
    setFilteredOnlineFees(response.data.data);
  };

  useEffect(() => {
    getAllOnlineFees();
  }, []);

  // Handle Search
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filteredData = onlineFees.filter(
      (item) =>
        item?.studentName.toLowerCase().includes(value) ||
        item?.parentEmail.toLowerCase().includes(value) ||
        item?.parentName.toLowerCase().includes(value)
    );
    setFilteredOnlineFees(filteredData);
  };

  const { confirm } = Modal;
  // Admission Status Update
  //   const handleStatusChange = (id, status) => {
  //     confirm({
  //       title: "Are you sure?",
  //       content: `Do you really want to change the status to "${status}"?`,
  //       okText: "Yes, Change",
  //       cancelText: "No, Cancel",
  //       onOk: async () => {

  //       },
  //     });
  //   };
  const handleStatusChange = (id, status) => {
    confirm({
      title: "Are you sure?",
      content: `Do you really want to change the status to "${status}"?`,
      okText: "Yes, Change",
      cancelText: "No, Cancel",
      onOk: async () => {
        try {
          // Call your API to update the status
          const response = await axios.put("/api/v1/fees/status", {
            feeId: id,
            status: status,
          });

          if (response.data.success) {
            message.success(response.data.message);
            // Refresh your data here if needed
            getAllOnlineFees();
          } else {
            message.error("Failed to update status");
          }
        } catch (error) {
          message.error(
            error.response?.data?.message || "Error updating status"
          );
        }
      },
    });
  };
  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      width: 10,
      sortable: false,
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      editable: true,
      renderCell: (params) => (
        <div style={{ width: "100%" }}>
          <select
            value={params?.row?.paymentStatus || ""}
            onChange={(e) =>
              handleStatusChange(params?.row?._id, e.target.value)
            }
            style={{
              padding: "6px 12px",
              fontSize: "14px",
              borderRadius: "8px",
              border: `1px solid ${
                params?.row?.paymentStatus === "success"
                  ? "green"
                  : params?.row?.paymentStatus === "failed"
                  ? "red"
                  : "#ccc"
              }`,
              backgroundColor:
                params?.row?.paymentStatus === "success"
                  ? "#e0ffe0"
                  : params?.row?.paymentStatus === "failed"
                  ? "#ffe0e0"
                  : "#fff",
              color:
                params?.row?.paymentStatus === "success"
                  ? "green"
                  : params?.row?.paymentStatus === "failed"
                  ? "red"
                  : "#333",
              cursor: "pointer",
              outline: "none",
              transition:
                "border-color 0.2s, background-color 0.2s, color 0.2s",
            }}
          >
            <option value="success">Paid</option>
            <option value="pending">Pending</option>
            <option value="failed">Failed</option>
          </select>
        </div>
      ),
    },
    {
      field: "studentName",
      headerName: "Student Name",
      width: 150,
    },
    {
      field: "parentName",
      headerName: "Parent Name",
      width: 150,
    },
    {
      field: "parentEmail",
      headerName: "E-mail",
      width: 200,
    },
    {
      field: "parentPhone",
      headerName: "Phone Number",
      width: 150,
    },
    {
      field: "studentClass",
      headerName: "Class Applied",
      width: 150,
    },
    {
      field: "rollNumber",
      headerName: "Roll Number",
      width: 120,
    },
    {
      field: "totalFees",
      headerName: "Total Fees",
      width: 120,
    },
    {
      field: "createdAt",
      headerName: "Date",
      width: 180,
      renderCell: (params) =>
        moment(params?.row?.createdAt).format("MM/DD/YYYY"),
    },
  ];
  return (
    <div>
      <PageTitle
        title="Manage Online Fees - Admin Panel | Shree Mangalam School"
        description="Track, manage, and update online fee transactions through the Admin Panel of Shree Mangalam School. Ensure secure and transparent fee collection and reporting."
        url="/admin/online-fees"
        keywords="online fees admin, school fee management, Shree Manglam fee panel, digital payments school, track student payments, admin fee dashboard"
      />

      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{
          mb: 3,
          fontFamily: "Poppins, sans-serif",
          color: "#2C3E50",
          letterSpacing: "2.5px",
          lineHeight: 1.8,
        }}
      >
        Online Fees
      </Typography>

      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          // mb: 2,
          mb: 5,
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <MUILink
          component={Link}
          to="/dashboard"
          sx={{ color: "inherit", textDecoration: "none" }}
        >
          Dashboard
        </MUILink>
        <Typography sx={{ color: "primary.main" }}>Online Fees</Typography>
      </Breadcrumbs>

      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search by Name, or Email"
        value={search}
        onChange={handleSearch}
        InputProps={{
          startAdornment: (
            <IconButton>
              <SearchIcon sx={{ color: "#1976d2" }} />
            </IconButton>
          ),
        }}
        sx={{
          mb: 3,
          bgcolor: "white",
          borderRadius: "20px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "none",
            },
            "&:hover fieldset": {
              border: "none",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
          },
        }}
      />
      <Box
        style={{
          width: "auto",
          overflowY: "hidden",
          overflowX: "scroll",
        }}
      >
        <Box
          sx={{
            pb: 2,
            display: "flex",
            width: "auto",
            justifyContent: "right",
          }}
        ></Box>
        <Table data={filteredOnlineFees} columns={columns} />
      </Box>
    </div>
  );
};

export default OnlineFees;
